import * as React from "react";
import { SVGProps } from "react";
const SvgCalendarIcon = (props: SVGProps<SVGSVGElement>) => <svg width={24} height={25} viewBox="0 0 24 25" {...props}><path d="M18.4 0h-1.6v2.4H7.2V0H5.6v2.4H0v22.4h24V2.4h-5.6V0zm4 23.2H1.6V10h20.8v13.2zm0-19.2v4.4H1.6V4h4v2h1.6V4h9.6v2h1.6V4h4z" /></svg>;
export default SvgCalendarIcon;